import React from "react";
import { Icon, Breadcrumbs, Button } from "@blueprintjs/core";
import { inject, observer } from "mobx-react";
import { withAuth0 } from "@auth0/auth0-react";
import SideNavbar from "../components/navigation/SideNavbar";
import LogoutButton from "../../micro/utils/LogOutButton";
import ThemeToggle from "../../components/ThemeToggle";
import BranchSelector from "../../micro/components/BranchSelector";
import SxPriceEstimator from "../components/SxPriceEstimator";
import "../styles/layout.css";

class AppLayout extends React.Component {
  state = {
    isMobileSidebarOpen: false,
  };

  toggleMobileSidebar = (e) => {
    e.stopPropagation(); // Prevent event from bubbling to document
    this.setState((prev) => ({ isMobileSidebarOpen: !prev.isMobileSidebarOpen }));
  };

  closeMobileSidebar = () => {
    this.setState({ isMobileSidebarOpen: false });
  };
  getBreadcrumbs = () => {
    const { pathname } = this.props.location || {};
    if (!pathname) return [];

    const pathParts = pathname.split("/").filter(Boolean);
    const breadcrumbs = [];

    if (pathParts[0] === "v3") {
      breadcrumbs.push({ text: "Home", icon: "home" });

      if (pathParts[1]) {
        const sectionName = pathParts[1].charAt(0).toUpperCase() + pathParts[1].slice(1);
        breadcrumbs.push({
          text: sectionName,
          icon: this.getSectionIcon(pathParts[1]),
        });

        if (pathParts[2]) {
          const pageName = pathParts[2]
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
          breadcrumbs.push({ text: pageName });
        }
      }
    }

    return breadcrumbs;
  };

  getSectionIcon = (section) => {
    const iconMap = {
      masters: "globe",
      reports: "th-list",
      surgeries: "cut",
      administration: "shield",
      workflow: "flow-branch",
    };
    return iconMap[section] || "document";
  };

  render() {
    const { children, auth0, authStore } = this.props;
    const breadcrumbs = this.getBreadcrumbs();

    return (
      <div className="v3-app-layout">
        {this.state.isMobileSidebarOpen && (
          <div
            className="v3-mobile-overlay"
            onClick={this.closeMobileSidebar}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 999,
            }}
          />
        )}

        <SideNavbar isMobileOpen={this.state.isMobileSidebarOpen} onMobileClose={this.closeMobileSidebar} />

        <div className="v3-main-content">
          <header className="v3-top-header" style={{ minHeight: "48px", padding: "0 16px" }}>
            <div className="v3-header-left">
              <Button minimal icon="menu" onClick={this.toggleMobileSidebar} className="v3-mobile-menu-button" />
            </div>
            <div className="v3-user-menu">
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginRight: 8 }}>
                <BranchSelector
                  showLabel={false}
                  label="Branch"
                  placeholder="Select branch..."
                  selectedBranch={authStore.selectedBranchName || ""}
                  onBranchChange={(val) => {
                    // Header selector uses names list, so persist name
                    authStore.setSelectedBranchByName(val || null);
                  }}
                />
              </div>
              <ThemeToggle />
              {/* <SxPriceEstimator /> */}
              <div className="v3-user-info">
                <Icon icon="person" />
                <span>{auth0.user?.name || authStore.name}</span>
              </div>
              <LogoutButton />
            </div>
          </header>

          <main className="v3-content-area">{children}</main>
        </div>
      </div>
    );
  }
}

export default inject("authStore")(observer(withAuth0(AppLayout)));
